<script setup>
import { usePage } from '@inertiajs/vue3'
import { computed, ref, onMounted } from 'vue'
import { resolveColourValue } from '@/Helpers/themeColourResolver';
import ImageZoomPopup from '@/Pages/Playlist/components/Misc/ImageZoomPopup.vue'
import { usePopupController } from '@/Composables/usePopupController';
const { showPopup  } = usePopupController();

import panzoom from 'panzoom'
const container = ref(null)
const img = ref(null)
const isTouch = ('ontouchstart' in window || navigator.maxTouchPoints > 0)
let panZoomInstance

const page = usePage()
const props = defineProps({
    row: {
        type: Object,
        default: undefined,
    },
    brand: { type: Object, default: () => ({}) },
    shift: { type: Number, default: 0 },
    scormExport: Boolean,
})

onMounted(() => {
    if (props.row.content.expandable !== 'true') return;

    const calculatePanzoomParams = () => {
        const containerRect = container.value.getBoundingClientRect();
        const imgNaturalWidth = img.value.naturalWidth;
        const imgNaturalHeight = img.value.naturalHeight;

        let initialZoom = 1;
        let initialX = 0;
        let initialY = 0;
        
        if ((imgNaturalHeight/imgNaturalWidth) < 1) initialZoom = 1 + (imgNaturalHeight/imgNaturalWidth);

        if (initialZoom > 1) {
            // initialX = (containerRect.width * initialZoom) / 2;
            // initialY = (containerRect.height * initialZoom) / 2;
        }

        return { initialZoom, initialX, initialY };
    };

    img.value.onload = () => {
        const { initialZoom, initialX, initialY } = calculatePanzoomParams();

        panZoomInstance = panzoom(img.value, {
            smoothScroll: true,
            minZoom: 0.5,
            bounds: true,
            boundsPadding: 0.25,
            initialZoom: initialZoom,
            initialX: initialX,
            initialY: initialY,
        });
    };

    if (img.value.complete) {
        img.value.onload();
    }
})

const imgPath = computed(() => {
    if (props.scormExport) {
        return props.row.content.file;
    }
    return 'https://' + page.props.s3_bucket + '.s3.' + page.props.s3_region + '.amazonaws.com/' + props.row.content.folder + '/' + props.row.content.file;
});

const openExpandedImage = () => {
    if (isTouch) return;
    showPopup(ImageZoomPopup, {
        imgPath: imgPath.value,
        alt: props.row.content.alt
    });
}

const imgFit = computed(() => {
    if (props.row.content.expandable  === 'true') return '';
    switch (props.row.content.fit) {
    case 'bg-cover':
        return 'object-cover';
    case 'bg-contain':
        return 'object-contain';
    default:
        return 'object-cover';
    }
});

const imgAlign = computed(() => {
    if (props.row.content.expandable  === 'true') return '';
    switch (props.row.content.align) {
    case 'bg-center':
        return 'object-center';
    case 'bg-top':
        return 'object-top';
    case 'bg-bottom':
        return 'object-bottom';
    case 'bg-left':
        return 'object-left';
    case 'bg-right':
        return 'object-right';
    default:
        return 'object-center';
    }
});

const imgSize = computed(() => {
    if (props.row.content.expandable  === 'true') return '';
    return 'w-full h-full';
});

const borderColour = computed(() => resolveColourValue(props.row?.content?.borderColour, props.brand, props.shift) || '');

const borderWidth = computed(() => {
    return props.row.content.borderWidth ? props.row.content.borderWidth : '0';
});

const borderRadius = computed(() => {
    return props.row.content.borderRadius ? props.row.content.borderRadius : '0';
});

const rowHeight = (rowContent) => {
    if (rowContent.height === 'h-full') return '100%';
    if (rowContent.height === 'h-1/4') return '25%';
    if (rowContent.height === 'h-1/2') return '50%';
    if (rowContent.height === 'h-3/4') return '75%';
    const parsedHeight = parseInt(rowContent.height, 10);
    if (!isNaN(parsedHeight)) {
        return parsedHeight + '%';
    }
    return '100%';
}
</script>
<template>
    <div 
        ref="container"
        class="w-full bg-no-repeat relative min-h-8 overflow-hidden"
        :style="'height: ' + rowHeight(row.content) + '; border-color: ' + borderColour + '; border-width: ' + borderWidth + 'px; border-radius: ' + borderRadius + '%;'"
    >
        <img ref="img" :src="imgPath" :alt="row.content.alt" :class="imgSize + ' ' + imgFit + ' ' + imgAlign">
        <div 
            v-if="row.content.expandable === 'true'" 
            class="absolute top-0 right-0 rounded-bl-lg bg-platform-gray text-platform-black py-2 px-3 text-xl cursor-pointer hover:bg-platform-orange-dark hover:text-white transition-all z-50"
            @click="openExpandedImage"    
        >
            <font-awesome-icon icon="fa-light fa-expand" />
        </div>
    </div>
</template>